<template>
  <div>
    <!-- Select a date -->
    <div v-if="activeScreen == 'selectDate'" :key="'selectPhoneDate'" class="vs-document-schedule common-consent-edu common-consent-edu d-flex flex-column">
      <div class="schedule-heading">
        <p v-translate:label_what_day_would_you_like_to_have_your_phone_call="lang">
          What day would you like to have your phone call?
        </p>
      </div>
      <ul class="telehealth custom-radio-button" v-if="availableSlots.length > 0">
        <label
          class="m-0"
          v-for="(slot, index) in availableSlots"
          :key="index"
          :class="{
            show: onShowMoreDates && index <= 4,
            hide: onShowMoreDates == false && index > 4
          }"
        >
          <li class="cursor_pointer" @click="selectSlotDate(slot)">
            <input type="radio" name="radio-button" value="css" /><span class="ml-15">{{ convertDate(slot.date, "dddd, MMMM DD") }}</span>
          </li>
        </label>
      </ul>
      <ul v-else class="telehealth custom-radio-button">
        <label>
          <li>
            <span v-translate:label_noappointment="lang">There are no available appointment times.</span>
          </li>
        </label>
      </ul>
      <div class="telehealth mt-auto">
        <button v-if="availableSlots.length > 5 && onShowMoreDates == false" @click="onShowMoreDates = onShowMoreDates ? false : true" type="button" class="btn btn-sm btn-default telehealth_show_more show-more-bg mt-16">
          <span v-translate:show_more_dates="lang" class="show-more-text">Show more dates</span>
          <span class="fa fa-angle-down fs-18 bottom-right"></span>
        </button>
        <div class="text-center vs-document-btn pt-48 mt-auto">
          <button class="btn btn-submit" v-translate:text_signin_button="lang" :disabled="Object.entries(slotDate).length == 0" @click="selectedScreen">
            Next
          </button>
        </div>
      </div>
    </div>
    <!-- Select a date -->

    <!-- Select a time -->
    <div v-else-if="activeScreen == 'selectTime'" :key="'selectPhoneTime'" class="vs-document-schedule common-consent-edu">
      <div class="schedule-heading">
        <p v-html="selectTimeLabel">These are available times on</p>
      </div>

      <ul class="telehealth custom-radio-button" v-if="slotDate">
        <label class="m-0" v-if="slotDate.slots.length == 0">
          <li>
            <span class="ml-15" v-translate:label_noappointment="lang">There are no available appointment times.</span>
          </li>
        </label>
        <label
          :class="{
            show: showMoreDates && index <= 4,
            hide: showMoreDates == false && index > 4
          }"
          class="m-0"
          v-for="(slot, index) in slotDate.slots"
          :key="index"
        >
          <li class="cursor_pointer" @click="selectSlotTime(slot)">
            <input type="radio" name="radio-button" :value="slot.slotStartTime" /><span class="ml-15">{{ convertTime(slot, "hh:mm A") }}</span>
          </li>
        </label>
      </ul>
      <div class="telehealth mt-auto">
        <button v-if="slotDate.slots.length > 5 && showMoreDates == false" @click="showMoreDates = showMoreDates ? false : true" type="button" class="btn btn-sm btn-default telehealth_show_more show-more-bg mt-16">
          <span v-translate:show_more_dates="lang" class="show-more-text">Show more times</span>
          <span class="fa fa-angle-down fs-18 bottom-right"></span>
        </button>
        <div class="text-center vs-document-btn pt-48 mt-auto">
          <button class="btn btn-submit" v-translate:text_signin_button="lang" :disabled="slotTime == null" @click="selectedScreen">
            Next
          </button>
        </div>
      </div>
    </div>
    <!-- Select a time -->

    <!-- Confirm appointment time -->
    <div v-else-if="activeScreen == 'confirmTime'" :key="'confirmPhoneTime'" class="vs-document-schedule common-consent-edu">
      <div class="schedule-heading">
        <p v-translate:label_enter_your_phone_number_and_confirm="lang">
          Enter your phone number for your visit and confirm the time to receive your call.
        </p>
      </div>

      <div class="time-box border-shadow border-none p-40 mt-30">
        <span>{{ convertDate(slotDate.date, "dddd, MMMM DD") }}<br />{{ widget.translate("LABEL_AT", "at") }} {{ convertTime(slotTime, "hh:mm A") }}</span>
        <vue-tel-input
          class="mb-0 mr-0 mt-20"
          @validate="phoneValidated"
          :placeholder="widget.translate('label_enter_phone_number', 'Enter your phone number')"
          :dropdownOptions="{ showDialCodeInSelection: true }"
          mode="international"
          validCharactersOnly
          type="tel-input"
          v-model="slotPhone"
          name="phoneNumber"
          :preferredCountries="['us']"
          :class="{
            input: true,
            'is-danger': errors.has('phoneNumber'),
            'is-success': !errors.has('phoneNumber')
          }"
        ></vue-tel-input>
        <span v-if="!isValidPhoneNumber && slotPhone !== null" v-translate:error_phNo="lang" class="error-style phone-error-style fs-14">Enter valid phone number</span>
      </div>
      <div class="telehealth mt-60">
        <span class="btn btn-sm btn-default telehealth_show_more tele-change-text" v-translate:label_changetime="lang" @click="changeSlotTime">Change appointment time</span>

        <div class="text-center vs-document-btn pt-48 mt-auto">
          <button class="btn btn-submit" v-translate:text_signin_button="lang" :disabled="!isValidPhoneNumber" @click="confirmSlotTime">
            Next
          </button>
        </div>
      </div>
    </div>
    <!-- Confirm appointment time -->

    <!-- Appointment Confirmed -->
    <div v-else-if="activeScreen == 'confirmed'" :key="'confirmedPhone'" class="vs-document-schedule common-consent-edu">
      <div class="schedule-heading">
        <p v-translate:label_confirm_visit_details="lang">
          Confirm your visit details below.
        </p>
      </div>

      <div class="mb-30 border-shadow border-none time-box p-40">
        <p>
          {{ convertDate(slotDate.date, "dddd, MMMM DD") }}<br />{{ widget.translate("LABEL_AT", "at") }}
          {{ convertTime(slotTime, "hh:mm A") }}
        </p>
        <span class="tel-confirm-phone">{{ $sanitize(slotPhone) }}</span>
      </div>
      <span class="btn btn-sm btn-default telehealth_show_more tele-change-text" v-translate:label_edit_your_visit="lang" @click="backToScreen">Edit your visit</span>
      <!-- <div class="mb-50 Progress-img-check"><img src="@/assets/ICN - green check big.png" alt="green check"></div> -->
      <div class="telehealth mt-auto">
        <div class="text-center vs-document-btn pt-48 mt-auto">
          <button class="btn btn-submit" v-translate:confirm="lang" @click="confirmAppointment">
            Confirm
          </button>
        </div>
      </div>
    </div>
    <!-- Appointment Confirmed -->
  </div>
</template>

<script>
import moment from "moment";
import { Widget, Telehealth, ParticipantPortal } from "@/components/services/participant-service";
export default {
  name: "telehealth-schedule-phonecall",
  components: {},
  props: ["lang", "availableSlots"],
  data() {
    return {
      widget: new Widget(),
      telehealth: new Telehealth(),
      portal: new ParticipantPortal(),

      screens: [
        { name: "selectDate", isActive: true },
        { name: "selectTime", isActive: false },
        { name: "confirmTime", isActive: false },
        { name: "confirmed", isActive: false }
      ],
      activeScreen: "selectDate",
      slotDate: {},
      slotTime: null,
      slotPhone: null,
      participantAddress: {
        countryCode: null,
        phoneNumber: null,
        smsCountryIsoName: null
      },
      confirmSlot: false,
      selectTimeLabel: null,
      showMoreDates: false,
      isValidPhoneNumber: false,
      onShowMoreDates: false
    };
  },
  computed: {
    language() {
      return this.$store.getters.getParticipantsPortalLanguages;
    }
  },
  methods: {
    phoneValidated(number) {
      this.isValidPhoneNumber = number.isValid;
      if (number.isValid) {
        this.participantAddress.countryCode = number.country.dialCode;
        this.participantAddress.smsCountryIsoName = number.country.iso2;
        this.participantAddress.phoneNumber = number.number.e164.replace("+" + number.country.dialCode, "");
      }
    },
    backToScreen(evt, screen = "selectDate") {
      this.activeScreen = screen;
      this.confirmSlot = false;
      this.screens = this.screens.map(e => {
        e.isActive = e.name == screen;
        return e;
      });
    },
    selectedScreen() {
      let newScreen = "";
      this.screens = this.screens.map(e => {
        e.isActive = false;
        return e;
      });
      if (Object.entries(this.slotDate).length == 0) {
        newScreen = this.screens.find(e => e.name == "selectDate");
      } else if (Object.entries(this.slotDate).length > 0 && this.slotTime !== null && this.confirmSlot) {
        newScreen = this.screens.find(e => e.name == "confirmed");
      } else if (Object.entries(this.slotDate).length > 0 && this.slotTime !== null) {
        newScreen = this.screens.find(e => e.name == "confirmTime");
      } else if (Object.entries(this.slotDate).length > 0) {
        newScreen = this.screens.find(e => e.name == "selectTime");
      }

      if (newScreen) {
        this.activeScreen = newScreen.name;
        this.screens = this.screens.map(e => {
          e.isActive = e.name == newScreen.name;
          return e;
        });
      }
    },
    convertTime(slot, format) {
      moment.locale(this.lang);
      const date = new Date(slot.slotStartTime);
      const m = moment(date);
      return format ? m.format(format) : m.format("MMMM DD, hh:mm A");
    },
    convertDate(dateString, format) {
      moment.locale(this.lang);
      const m = moment(dateString);
      return format ? m.format(format) : m.format("MMMM DD, hh:mm A");
    },
    selectSlotDate(slot) {
      const message = this.widget.translate(
        "question_whattime",
        `These are available times on %1$s. 

 Select a time.`
      );
      this.selectTimeLabel = message.replace("%1$s", this.convertDate(slot.date, "dddd, MMMM DD")).replace("\n", "<br><br>");
      this.slotDate = slot;
      this.slotTime = null;
    },
    selectSlotTime(slot) {
      this.slotTime = slot || null;
    },
    changeSlotTime() {
      this.slotTime = null;
      this.selectedScreen();
    },
    confirmSlotTime() {
      if (this.slotTime) {
        this.confirmSlot = true;
      }
      this.selectedScreen();
    },
    confirmAppointment() {
      this.$emit("updateActiveScreen", {
        date: this.slotDate,
        time: this.slotTime,
        address: this.participantAddress
      });
    }
  }
};
</script>

<style>
.tel-confirm-phone {
  font-size: 18px !important;
}
.error-style {
  color: red;
  font-size: 12px !important;
}
.telehealth.custom-radio-button label.hide {
  display: none;
}
.card.learn-card.disabled {
  opacity: 0.6;
}
ul.telehealth li:hover {
  background-color: #eceaea;
}
.activity-progress-row {
  padding: 13px 0 10px 0;
}

.calender-icon {
  margin-top: -5px;
}
.progress {
  border: solid 1px var(--primary);
  background-color: #f3f3f3;
  height: 12px;
  margin-top: 5px;
  border-radius: 10px;
}
.progress-bar {
  background-color: var(--primary);
}
.vs-document-schedule {
  width: 100%;
  max-width: 100%;
}
.vs-document-btn {
  padding: 48px 0px 26px;
}
.show-more-bg {
  background-color: transparent;
}
.show-more-bg .fa-angle-down {
  color: #4c6473;
}
.show-more-bg .show-more-text {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: -0.32px;
  text-align: center;
  color: #4c6473;
}
.tele-change-text {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: -0.32px;
  text-align: center;
  color: #4c6473;
}
.Progress-img-check {
  width: 165px;
  height: 165px;
  margin: 0 auto 100px auto;
}
.custom-radio-button label {
  display: block;
}
.custom-radio-button label > li > input[type="radio"] {
  display: none;
}
.custom-radio-button label > li > input[type="radio"] + *::before {
  content: "";
  display: inline-block;
  vertical-align: bottom;
  width: 1.3rem;
  height: 1.3rem;
  margin-right: 0.3rem;
  border-radius: 50%;
  border-style: solid;
  border-width: 2px;
  border-color: gray;
}
.custom-radio-button label > li > input[type="radio"]:checked + *::before {
  background: radial-gradient(var(--primary) 0%, var(--primary) 40%, transparent 50%, transparent);
  border-color: var(--primary);
}
.vti__input {
  border: none;
  border-radius: 0 2px 2px 0;
  width: 100%;
  outline: 0;
  padding-left: 7px;
  font-size: 16px !important;
}
.vti__dropdown-item {
  cursor: pointer;
  padding: 4px 15px;
  font-size: 13px !important;
}
</style>
